import { type IDropdownItem } from 'shared/ui'
import { type IInboxTreeCombine } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeTeamsFavorite = 'favorite'

type IActionTeamsFavorite = {
  inbox: IInboxTreeCombine
  groupInbox?: IInboxTreeCombine
  item: IDropdownItem
}

export const menuTeamsFavorite = (inbox: IInboxTreeCombine): IDropdownItem => {
  return {
    id: typeTeamsFavorite,
    iconL: inbox.isFavoriteType ? 'starFilled1' : 'starLine',
    label: inbox.isFavoriteType ? 'Unfavorite' : 'Favorite',
  }
}

export const actionTeamsFavorite = async (
  { inbox, groupInbox, item }: IActionTeamsFavorite,
  store: ConversationMenuStore
) => {
  if (item.id === typeTeamsFavorite) {
    store.handleUpdateTeamsFavorite({
      inbox: inbox,
      groupInbox: groupInbox,
      status: !inbox.isFavoriteType,
    })
  }
}
